'use strict';

module.exports = {
    clickButton: function () {
        $('#confirm-yes').click(function (e) {
            e.preventDefault();
            let url = $(this).data('url');
            let confirm = $(this).data('confirm');
            let data = {
                confirm: confirm,
            };
            $.spinner().start();
            // 通信
            $.ajax({
                url: url,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (response) {
                    $.spinner().stop();
                    // ダイアログを閉じる
                    if (response.success) {
                        $('#confirm-modal').remove();
                    }
                },

                error: function (err) {
                    $.spinner().stop();
                    // SFRA準拠
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                },
            });
        });
    },

    //　確認モーダルの表示
    showConfirmModal: function () {
        if ($('#consent-tracking') && $('#consent-tracking').length > 0) {
            return;
        }
        let hidVal = $('#confirm-agree').val();
        // モーダル画面を表示
        if (hidVal === 'null' || hidVal === '0') {
            let view = $('#confirm-modal');
            view.modal('show');
        }
    },
};
